import { render, staticRenderFns } from "./Performance.vue?vue&type=template&id=2b77caf3&scoped=true&"
import script from "./Performance.vue?vue&type=script&lang=ts&"
export * from "./Performance.vue?vue&type=script&lang=ts&"
import style0 from "./Performance.vue?vue&type=style&index=0&id=2b77caf3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b77caf3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VContainer,VDataTable})
